import React, { useState, useEffect, useContext } from "react";
import { WidthProvider, Responsive } from "react-grid-layout";
import Card from "react-bootstrap/Card";
import PriceListQuickLink from "./PriceListQuickLink";
import CertificateDetailQuckLink from "./CertificateDetailQuckLink";
import DailyInvoiceNumber from "./DailyInvoiceNumber";
import UnfiscalInvoicesTotal from "./UnfiscalInvoicesTotal";
import ClientDetailQuckLink from "./ClientDetailQuckLink";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { globalServices } from "../../Services/global.service";
import "../../../node_modules/react-grid-layout/css/styles.css";
import "../../../node_modules/react-resizable/css/styles.css";

const DashboardLayoutQuickLinks = (props) => {
  const { updatePerformances } = useContext(GlobalContext);
  const ResponsiveGridLayout = WidthProvider(Responsive);

  const onLayoutChange = (layout, layouts) => {
    saveToLocalStorage("layouts", layouts);
  };

  const [widgets, setWidgets] = useState(null);



  const saveToLocalStorage = (key, value) => {
    if (global.localStorage) {
      global.localStorage.setItem(
        "cardsOrderStatistics",
        JSON.stringify({
          [key]: value,
        })
      );
    }
  };

  for (let t = 0; t <= 300; t += 10) {
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, t);
  }

  const loadFromLocalStorage = (key) => {
    let localStorage = {};
    if (global.localStorage) {
      try {
        localStorage =
          JSON.parse(global.localStorage.getItem("cardsOrderStatistics")) || {};
      } catch (e) {
        // ignore for now
      }
    }
    return localStorage["layouts"];
  };

  const originalLayouts = JSON.parse(
    JSON.stringify(loadFromLocalStorage("cardsOrderStatistics") || {})
  );
  const [layouts, setLayouts] = useState(originalLayouts);

  return (
    <> <h2>Brzi linkovi</h2>
      {  (
        <ResponsiveGridLayout
          className="layout"
          cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
          rowHeight={100}
          layouts={layouts}
          width={1200}
          isDraggable={false}
          isResizable={false}
          onLayoutChange={(layout, layouts) => onLayoutChange(layout, layouts)}
        >
            
          <Card
            hidden={false}
            key={"priceListQuickLink"}
            data-grid={{ x: 0, y: 0, w: 2, h: 2 }}
            className="text-center dashboard dashboard-tenant-data"
          >
            <PriceListQuickLink />
          </Card>

         

          <Card
            hidden={false}
            key={"clientDetailQuckLink"}
            data-grid={{ x: 2, y: 0, w: 2, h: 2 }}
            className="text-center dashboard dashboard-tenant-data"
          >
          
             <ClientDetailQuckLink />
           
          </Card>
           

           <Card
            hidden={false}
            key={"certDetailQuckLink"}
            data-grid={{ x: 4, y: 0, w: 2, h: 2 }}
            className="text-center dashboard dashboard-tenant-data"
          >
            <CertificateDetailQuckLink />
          </Card>
        </ResponsiveGridLayout>
      )}
    </>
  );
};

export default DashboardLayoutQuickLinks;
